import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { responsePQRS, getListPQRS, getListTypePQRS, disablePQRS } from '../../actions/pqrsActions'
import { Translate } from '../../../language';
import Modal from '../../../containers/Modal';
import inMemoryJWT from '../../../auth/inMemoryJwt';
import { Table } from '../Table/Table';
import Button from '../../../utils/components/Button/Button';

const PQRSAdmin = ({ history, responsePQRS, listPQRSAdmin, getListPQRS, getListTypePQRS, disablePQRS, isLoadingListPQRSAdmin }) => {

    /* const [isEdit, setIsEdit] = useState(false)
    const [idEdit, setIdEdit] = useState('')
    const [indexEdit, setIndexEdit] = useState('')
    const [affair, setAffair] = useState('') */
    const [reply, setReply] = useState('')
    /* const [description, setDescription] = useState('')
    const [typePQRS, setTypePQRS] = useState('') */
    const [listTypePQRS, setListTypePQRS] = useState('')
    const [isValidate, setValidate] = useState(false)
    const [error, setError] = useState({})
    /* const [isEnable, setEnable] = useState(false)
    const [urlPicture, setUrlPicture] = useState('')
    const [dataFile, setDataFile] = useState(null) */
    const [isModalOpenInvalidate, setIsModalOpenInvalidate] = useState(false)
    const [isModalOpenResponse, setIsModalOpenResponse] = useState(false)
    const [pqrtsID, setPqrtsID] = useState(null)


    /* useEffect(() => {
        if (!(inMemoryJWT.getToken())) {
            inMemoryJWT.getRefreshedToken()
        }

        inMemoryJWT.waitForTokenRefresh().then(() => {
            getListPQRS()
        })

    }, []) */

    useEffect(() => {
        if (listTypePQRS !== '') {
            getListTypePQRS(listTypePQRS)
        }
    }, [listTypePQRS])

    const isFocused = (e) => {
        const { name } = e.target;
        setError(prevError => ({
            ...prevError,
            [name]: ''
        }));
    }
    /* const handleSelectTypePQRS = (e) => {
        var { value } = e.target;
        setTypePQRS(value)
    } */

    const handleSelectListTypePQRS = (e) => {
        var { value } = e.target;
        setListTypePQRS(value)
    }


    const isEmpty = (e) => {
        const { name, placeholder, value } = e.target;
        if (value.length === 0) {
            setValidate(false)
            setError(prevError => ({
                ...prevError,
                [name]: Translate('missingField', 'es') + placeholder
            }));
        }
        if (value.length !== 0) {

            setError(prevError => ({
                ...prevError,
                [name]: ''
            }));
        }

    }
    console.log()


    const selectModalInvalidate = (e) => {
        e.stopPropagation()
        setIsModalOpenInvalidate(!isModalOpenInvalidate)
        setIsModalOpenResponse(false)
    }

    const selectModalResponse = (e) => {
        e.stopPropagation()
        setIsModalOpenResponse(!isModalOpenResponse)
        setIsModalOpenInvalidate(false)
    }
    console.log()
    return (
        <div className="row container-mark-type-admin centerItems centerContent">
            <div className="see-all-mark-type-admin">
                <select value={listTypePQRS} className='input-select-style' name="listTypePQRS" id="listTypePQRS" placeholder='PQRS' onChange={(e) => { handleSelectListTypePQRS(e) }}>
                    <option value=''>Seleccione el estado</option>
                    <option value={0}>Enviadas</option>
                    <option value={1}>En espera</option>
                    <option value={2}>Resuelta</option>
                </select>

                {isLoadingListPQRSAdmin ? <div>Cargando...</div> :
                    <Table>
                        <thead>
                            <tr>
                                <th>Tipo</th>
                                <th>Informante</th>
                                <th>Asunto</th>
                                <th>Descripción</th>
                                {listTypePQRS != 2 && <th>Responder</th>}
                            </tr>
                        </thead>
                        <tbody>
                            {listPQRSAdmin && listPQRSAdmin.map((pqrs, index) => {
                            
                                const dataUser = pqrs?.userId ? {
                                    _id: pqrs.userId._id,
                                    name: pqrs.userId.name,
                                    lastname: pqrs.userId.lastname,
                                    picture: pqrs.userId && pqrs.userId.picture && pqrs.userId.picture.url && pqrs.userId.picture.url.origin
                                } :
                                    pqrs?.franchiseID ?
                                        {
                                            _id: pqrs.franchiseID._id,
                                            name: pqrs?.franchiseID.socialReason,
                                            lastname: "",
                                            picture: pqrs.franchiseID && pqrs.franchiseID.picture && pqrs.franchiseID.picture.url && pqrs.franchiseID.picture.url.origin
                                        } :
                                        pqrs?.franchiseId ?
                                            {
                                                _id: pqrs.franchiseId._id,
                                                name: pqrs?.franchiseId.socialReason,
                                                lastname: "",
                                                picture: pqrs.franchiseId && pqrs.franchiseId.picture && pqrs.franchiseId.picture.url && pqrs.franchiseId.picture.url.origin
                                            } :
                                            pqrs?.representativeID ?
                                                {
                                                    _id: pqrs?.representativeID._id,
                                                    name: pqrs?.representativeID.userID.name,
                                                    lastname: pqrs?.representativeID.userID.lastname,
                                                    picture: pqrs.representativeID.userID && pqrs.representativeID.userID.picture && pqrs.representativeID.userID.picture.url && pqrs.representativeID.userID.picture.url.origin
                                                } :
                                                pqrs?.representativeId ?
                                                    {
                                                        _id: pqrs?.representativeId._id,
                                                        name: pqrs?.representativeId.userID.name,
                                                        lastname: pqrs?.representativeId.userID.lastname,
                                                        picture: pqrs.representativeId.userID && pqrs.representativeId.userID.picture && pqrs.representativeId.userID.picture.url && pqrs.representativeId.userID.picture.url.origin
                                                    } :
                                                    pqrs?.warehouseId ?
                                                        {
                                                            _id: pqrs?.warehouseId._id,
                                                            name: pqrs?.warehouseId.name,
                                                            lastname: "",
                                                            picture: pqrs.warehouseId.profileId && pqrs.warehouseId.profileId.picture && pqrs.warehouseId.profileId.picture.url && pqrs.warehouseId.profileId.picture.url.origin
                                                        } : {
                                                            _id: "",
                                                            name: "",
                                                            lastname: "",
                                                            lastname: "",
                                                            picture: "",
                                                        }

                                return <tr key={pqrs._id}>
                                    <td>{Translate(pqrs.type, "es")}</td>
                                    <td>{dataUser.name} {dataUser.lastname}</td>
                                    <td>{pqrs.petitionSubject}</td>
                                    <td>{pqrs.description}</td>
                                    {listTypePQRS != 2 && <td>
                                        <Button text='Responder'

                                            onClick={() => {
                                                setPqrtsID(pqrs)
                                                setIsModalOpenInvalidate(true)
                                            }} />
                                    </td>}
                                </tr>
                            })
                            }
                        </tbody>
                    </Table>
                }
                <Modal displayModal={isModalOpenInvalidate} content={<div className='center'>
                    <textarea
                        rows="4"
                        style={{ resize: "none" }}
                        className='input-room-create'
                        name="reply"
                        value={reply}
                        type="text"
                        placeholder='Respuesta'
                        autoComplete="off"
                        onChange={(e) => {
                            setReply(e.target.value.trimStart())
                            if (reply !== '') {
                                setValidate(true)
                            }
                        }}
                        onBlur={e => isEmpty(e)}
                        onFocus={e => isFocused(e)}
                        onKeyUp={isEmpty ? e => isEmpty(e) : () => { }}
                        onMouseOut={e => setReply(e.target.value.trim())}
                    />
                    <div className="text-error">{error.reply}</div>
                    {
                        pqrtsID?._id && <div className='column'>
                            {
                                (pqrtsID.status === 0) && <Button text='en espera' onClick={() => {
                                    responsePQRS({
                                        pqrsId: pqrtsID._id,
                                        status: 1,
                                        reply
                                    })
                                    setReply(null)
                                    setIsModalOpenInvalidate(false)
                                }} />
                            }
                            <Button text='resuelta' onClick={() => {
                                responsePQRS({
                                    pqrsId: pqrtsID._id,
                                    status: 2,
                                    reply
                                })
                                setIsModalOpenInvalidate(false)
                            }} />

                        </div>
                    }

                </div>} closeModal={selectModalInvalidate}></Modal>

            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        isLoadingListPQRSAdmin: state.pqrsAdmin.isLoadingListPQRSAdmin,
        listPQRSAdmin: state.pqrsAdmin.listPQRSAdmin
    }
}


export default connect(mapStateToProps, { responsePQRS, getListPQRS, getListTypePQRS, disablePQRS })(PQRSAdmin)